import { useState, useContext } from 'react';
import { PageContext } from 'gatsby-theme-apollo';

const useLimitedSet = ({ initialLimit, interval, set, contentType }) => {
  const { logEvent } = useContext(PageContext);

  const [currentLimit, setCurrentLimit] = useState(initialLimit);
  const [limitedSet, setLimitedSet] = useState(
    initialLimit ? [...set].slice(0, initialLimit) : set
  );

  const increaseLimit = () => {
    const newLimit = currentLimit + interval;
    logEvent('limit_increase', { currentLimit, newLimit, contentType });
    setCurrentLimit(newLimit);
    setLimitedSet([...set].slice(0, newLimit));
  };

  return [limitedSet, currentLimit, increaseLimit];
};

export default useLimitedSet;
